import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-edit-customs-group__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeMultiselect = _resolveComponent("TreeMultiselect")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    title: _ctx.isEdit ? 'Редактирование группы' : 'Добавление в иерархию',
    onClose: _ctx.onClose,
    modelValue: _ctx.internalShow,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.internalShow) = $event)),
    width: 632,
    class: "add-edit-customs-group",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "add-edit-customs-group__form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"])),
        onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]), ["enter"]))
      }, [
        _createVNode(_component_InputBlock, {
          title: "Родитель",
          mode: "vertical",
          class: "add-edit-customs-group__field"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TreeMultiselect, {
              modelValue: _ctx.parentModel,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parentModel) = $event)),
              options: _ctx.groupsTree,
              valueProp: "id",
              labelProp: "name",
              childrenProp: "children",
              placeholder: "Выберите",
              customValidations: _ctx.parentCustomValidation,
              textError: _ctx.parentValidationMessage,
              dropdownMaxHeight: 200,
              isDirtyValidation: "",
              isSingleMode: "",
              menuMode: _ctx.menuModes.NONE
            }, null, 8, ["modelValue", "options", "customValidations", "textError", "menuMode"])
          ]),
          _: 1
        }),
        _createVNode(_component_InputBlock, {
          title: "Наименование",
          mode: "vertical",
          required: "",
          class: "add-edit-customs-group__field"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ComponentInput, {
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
              mod: "rectangular",
              placeholder: "Введите",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_InputBlock, {
          title: "Код",
          mode: "vertical",
          class: "add-edit-customs-group__field"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ComponentInput, {
              modelValue: _ctx.form.kod,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.kod) = $event)),
              mod: "rectangular",
              placeholder: "Введите"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ButtonComponent, {
            mod: "gradient-bg",
            buttonType: "submit",
            disabled: _ctx.v$.$invalid
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Сохранить ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_ButtonComponent, {
            mod: "transparent-bg",
            buttonType: "button",
            onClick: _ctx.onClose
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Отменить ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title", "onClose", "modelValue"]))
}